import { getLocale } from "src/i18n/i18n";
import { getLocalization } from "src/utils";

export const formatNumberAsPercentage = (value: any): string => {
    const num = parseFloat(value);

    if (Number.isNaN(num)) {
        return "";
    }

    return Intl.NumberFormat(getLocalization().locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
        style: "percent",
    }).format(num);
};

export const formatNumber = (value: any): string => {
    const num = parseFloat(value);

    if (Number.isNaN(num)) {
        return "";
    }

    return Intl.NumberFormat(getLocale(), {
        maximumSignificantDigits: 6,
        minimumSignificantDigits: 1,
    }).format(num);
};
